import './bootstrap';
import { createApp } from "vue";
import { plugin as VueTippy } from 'vue-tippy';
import VueScrollTo from 'vue-scrollto';
import Vuetable from 'vue3-vuetable';
import EventBus from './GlobalEventBus';
import components from './components';
const app = createApp({});
app.directive('focus', {
    // When the bound element is inserted into the DOM...
    mounted(el) {
        // Focus the element
        el.focus();
    },
});
app.provide('eventBus', new EventBus());
components.register(app);
app.use(Vuetable);
app.use(VueScrollTo);
// Use the Vue Tippy plugin
app.use(VueTippy, {
    directive: 'tooltip', // => v-tooltip
    component: 'tippy-tooltip', // => <tippy-tooltip/>
    componentSingleton: 'tooltip-singleton', // => <tippy-singleton/>,
    defaultProps: {
        placement: 'auto-start',
        // placement: 'auto-end',
        allowHTML: true,
    }, // => Global default options * see all props
});
app.mount('#app');
